import { RemoteStudentsCount } from 'data/usecases';
import { StudentsCountUseCaseInterface } from 'domain/usecases';
import { makeApiUrlAdminEntity } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteStudentsCount = (): StudentsCountUseCaseInterface =>
  new RemoteStudentsCount(makeApiUrlAdminEntity(), makeAxiosHttpClient());
